module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/marquee_mobile3-1e63e271e45f3300dbcf664c9e6b938b.jpg";